
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';


const EnterpriseSectorButton = ({sector, currentSector, handleSelectSector, canEdit, sectorState, setSector}) => {
    
    let bttnWidth = sector.type !== 'LandAndCrops'?'8%':null
    return (
        <Button
            color={currentSector && currentSector.id === sector.id ? 'primary' : 'secondary'}
            variant={currentSector && currentSector.id === sector.id ? 'contained' : 'outlined'}
            sx={{
                textTransform: 'none', marginLeft: '2px',
                padding: '3px 8px', lineHeight: 'normal',
                width: bttnWidth
            }}
            size="small"
            endIcon={
                <Checkbox size='small'
                    sx={{ padding: '2px' }}
                    color={currentSector && currentSector.id === sector.id ? 'primary' : 'secondary'}
                    checked={sectorState}
                    onClick={(e) => canEdit && handleSelectSector(e, sector, sector.id)}
                />}
            onClick={() => {setSector(sector);}}
        >
            {sector.sectorName.trim()}
        </Button>
    )
}

export default EnterpriseSectorButton;